import type { ReactNode } from 'react';

export const symbol_priority_high: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M479.91-120q-28.91 0-49.41-20.59-20.5-20.59-20.5-49.5t20.59-49.41q20.59-20.5 49.5-20.5t49.41 20.59q20.5 20.59 20.5 49.5t-20.59 49.41q-20.59 20.5-49.5 20.5Zm0-240q-28.91 0-49.41-20.56Q410-401.13 410-430v-340q0-28.88 20.59-49.44t49.5-20.56q28.91 0 49.41 20.56Q550-798.88 550-770v340q0 28.87-20.59 49.44Q508.82-360 479.91-360Z"
		/>
	</svg>
);
